export default __webpack_public_path__ + "static/media/SkyQ-Tech-logo.982d2229.svg";